import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod/v4";

export const createSubscription = unaryRpc({
  name: "createSubscription",
  input: z.object({
    productId: z.string(), // The subscription product ID
    customerEmail: z.string().email(), // Customer email to find or create customer
    variantId: z.string(), // Required variant selection
    quantity: z.number().default(1).optional(),
    // Default to monthly subscription for now
    orderIntervalFrequency: z.number().default(1).optional(),
    orderIntervalUnit: z
      .enum(["day", "week", "month"])
      .default("month")
      .optional(),
    chargeIntervalFrequency: z.number().default(1).optional(),
    // Customer info for creation if customer doesn't exist
    customerFirstName: z.string().optional(),
    customerLastName: z.string().optional(),
    customerPhone: z.string().optional(),
    // Address info for creation if address doesn't exist
    address1: z.string().optional(),
    address2: z.string().optional(),
    city: z.string().optional(),
    province: z.string().optional(),
    zip: z.string().optional(),
    countryCode: z.string().optional(),
    orderId: z.string().optional(),
  }),
  output: z.object({
    subscriptionId: z.string().optional(),
    status: z
      .enum([
        "ACTIVE",
        "CANCELLED",
        "EXPIRED",
        "active",
        "cancelled",
        "expired",
      ])
      .optional(),
    nextChargeDate: z.string().optional(),
    success: z.boolean(),
  }),
});
